module.exports = __webpack_public_path__ + "img/Moldova_GP3.196e54a1.jpeg";